
import {defineComponent} from 'vue';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';

export default defineComponent({
  name: 'oxd-autocomplete-text-input',
  inheritAttrs: false,

  emits: ['clear'],

  components: {
    'oxd-icon': Icon,
  },

  props: {
    style: {
      type: Object,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      focused: false,
    };
  },

  computed: {
    classes(): object {
      return {
        'oxd-autocomplete-text-input': true,
        'oxd-autocomplete-text-input--active': !this.focused,
        'oxd-autocomplete-text-input--focus': this.focused,
        'oxd-autocomplete-text-input--error': this.hasError,
        'oxd-autocomplete-text-input--disabled': this.disabled,
        'oxd-autocomplete-text-input--readonly': this.readonly,
      };
    },
  },

  methods: {
    onFocus($e: Event) {
      if (this.disabled || this.readonly) {
        $e.stopImmediatePropagation();
        return;
      }
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
    },
    onClear() {
      this.$emit('clear');
    },
  },
});
